function isOnScreen(elem) {

    // if the element doesn't exist, abort
    
    if( elem.length == 0 ) {
    
    return;
    
    }
    
    var $window = jQuery(window)
    
    var viewport_top = $window.scrollTop()
    
    var viewport_height = $window.height()
    
    var viewport_bottom = viewport_top + viewport_height
    
    var $elem = jQuery(elem)
    
    var top = $elem.offset().top+500;
    
    var height = $elem.height()
    
    var bottom = top + height
    
    return (top >= viewport_top && top < viewport_bottom) ||
    
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    
    (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
    
}

jQuery( document ).ready( function($) {

    window.addEventListener('scroll', function(e) {
    
        if( isOnScreen( $( '.grey-bulb' ) ) ) { /* Pass element id/class you want to check */
            $('.grey-bulb img').attr('src', '/wp-content/themes/greenslate/assets/images/Proactive_Advice_Active.jpg');
            $('.grey-bulb img').attr('srcset', '/wp-content/themes/greenslate/assets/images/Proactive_Advice_Active.jpg');
        }else if(!isOnScreen( $( '.grey-bulb' ) ) ){
            $('.grey-bulb img').attr('src', '/wp-content/themes/greenslate/assets/images/Proactive_Advice_Inactive.jpg');
            $('.grey-bulb img').attr('srcset', '/wp-content/themes/greenslate/assets/images/Proactive_Advice_Inactive.jpg');
        }

        if( isOnScreen( $( '.grey-computer' ) ) ) { /* Pass element id/class you want to check */
            $('.grey-computer img').attr('src', '/wp-content/themes/greenslate/assets/images/Technology_Enabled_Service_Active.jpg');
            $('.grey-computer img').attr('srcset', '/wp-content/themes/greenslate/assets/images/Technology_Enabled_Service_Active.jpg');
        }else if(!isOnScreen( $( '.grey-bulb' ) ) ){
            $('.grey-computer img').attr('src', '/wp-content/themes/greenslate/assets/images/Technology_Enabled_Service_Inactive.jpg');
            $('.grey-computer img').attr('srcset', '/wp-content/themes/greenslate/assets/images/Technology_Enabled_Service_Inactive.jpg');
        }
    
    });
    
});